exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".averagePayment[data-v-43a7a976]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.averagePayment .recipientAvgPayment[data-v-43a7a976]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;height:41px}.averagePayment[data-v-43a7a976] .el-progress-bar__innerText{color:transparent}.averagePayment[data-v-43a7a976] .el-progress{width:250px}", ""]);

// exports
